import React from "react";
import { NavLink } from "react-router-dom";
import BaseCounter from "../../../BaseCounter";
import BaseIcon from "../../../BaseIcon";
import "./style.scss";

interface Props {
  unreadThreadsCount: number;
  countUpcomingEvents: number;
}

export default function QuickSmallNavigator({ unreadThreadsCount, countUpcomingEvents }: Props) {
  return (
    <div className="quick-small-navigator d-center mr-6">
      <NavLink to="/favorites" className="quick-small-navigator__link">
        <BaseIcon>favorites</BaseIcon>
      </NavLink>
      <NavLink to="/messages" className="quick-small-navigator__link">
        <div className="quick-small-navigator__link-content">
          <BaseIcon>messages</BaseIcon>
          <BaseCounter className="quick-small-navigator__message-counter">{unreadThreadsCount}</BaseCounter>
        </div>
      </NavLink>
      <NavLink to="/user/appointments/" className="quick-small-navigator__link">
        <div className="quick-small-navigator__link-content">
          <BaseIcon>available</BaseIcon>
          <BaseCounter className="quick-small-navigator__calendar-counter">{countUpcomingEvents}</BaseCounter>
        </div>
      </NavLink>
    </div>
  );
}
